// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__YdLJn","content":"styles_content___9Pxi","text":"styles_text__rflQC","btnWrap":"styles_btnWrap__xojJd"};